import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import { useAuth } from "src/hooks/useAuth.hook";
import { useGetDetail, useMutate } from "src/hooks/useFetch.hook";
import { companyFeatureEntitlementsUrl } from "src/react-query/endPoints";
import { FEATURE } from "src/util/enums";
import CommonAccordion from "../CommonAccordion/CommonAccordion";
import { Loader } from "../Loader";

const CompanyFeatureEntitlements = ({
  companyId,
  expanded,
  onAccordionChange,
}) => {
  const { user } = useAuth();
  const isRootUser =
    user?.company?.id === 1 && user?.company?.companyType === "GP";

  const { data: entitlements, isFetching } = useGetDetail(
    "companyFeatureEntitlements",
    { id: isRootUser ? companyId : null }
  );
  const { mutate, isLoading } = useMutate("companyFeatureEntitlements", {
    id: companyId,
  });

  if (!isRootUser) {
    return null;
  }

  const fleetFeature = entitlements?.features?.find(
    (feature) => feature.featureName === FEATURE.FLEET_MANAGEMENT
  );

  const handleFleetToggle = (e) => {
    mutate({
      url: companyFeatureEntitlementsUrl(companyId),
      method: "PUT",
      body: {
        features: [
          { featureName: FEATURE.FLEET_MANAGEMENT, enabled: e.target.checked },
        ],
      },
    });
  };

  return (
    <CommonAccordion
      title="Feature Entitlements"
      onChange={onAccordionChange}
      expanded={expanded}
    >
      {isFetching ? (
        <Loader />
      ) : (
        <Card sx={{ p: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} className="enable-features__switch">
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item>
                  <Typography>Fleet Management</Typography>
                  <Typography variant="caption" color="text.secondary">
                    Allow this company to use the Fleet module
                  </Typography>
                  {!!fleetFeature?.enabled && fleetFeature?.enabledAt && (
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      display="block"
                    >
                      Enabled
                      {fleetFeature.enabledBy
                        ? ` by user ${fleetFeature.enabledBy}`
                        : ""}{" "}
                      on {new Date(fleetFeature.enabledAt).toLocaleString()}
                    </Typography>
                  )}
                </Grid>
                <Grid item>
                  <Switch
                    checked={!!fleetFeature?.enabled}
                    onChange={handleFleetToggle}
                    disabled={isLoading}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      )}
    </CommonAccordion>
  );
};

export default CompanyFeatureEntitlements;
